module.exports = __webpack_public_path__ + "static/t-shirts-1b1fcf74176b828c33e9f24676a6c4dc.png";